const getTemporaryOrders = () => {
  return [
    {
      id: 1,
      title: 'Canadiens de Montréal vs Columbus Blue Jackets',
      date: '16 novembre 2024 | 19:00',
      location: 'Centre Bell',
      city: 'Montréal',
      image: 'https://picsum.photos/400/200?random=1', // Placeholder image,
      type: 'product',
      price: 10,
      quantity: 1,
      status: "pending", // other values: "approved", "rejected"
    },
    {
      id: 2,
      title: 'Lendemain de Veille',
      date: '16 novembre 2024 | 20:00',
      location: 'Théâtre Beanfield',
      city: 'Montréal',
      image: 'https://picsum.photos/400/200?random=2',
      type: 'product',
      price: 12,
      quantity: 1,
      status: "pending", // other values: "approved", "rejected"
    },
    {
      id: 3,
      title: 'BUSH',
      date: '16 novembre 2024 | 20:00',
      location: 'Le Studio TD',
      city: 'Montréal',
      image: 'https://picsum.photos/400/200?random=3',
      type: 'service',
      price: 18,
      quantity: 1,
      status: "pending", // other values: "approved", "rejected"
    },
    {
      id: 4,
      title: 'Games We Play',
      date: '16 novembre 2024 | 20:00',
      location: 'Bar le "Ritz" PDB',
      city: 'Montréal',
      image: 'https://picsum.photos/400/200?random=4',
      type: 'service',
      price: 30,
      quantity: 1,
      status: "approved", // other values: "approved", "rejected"
    },
    {
      id: 5,
      title: 'Just An Event Rejected',
      date: '16 novembre 2024 | 20:00',
      location: 'Chez Maxime',
      city: 'Quebec',
      image: 'https://picsum.photos/400/200?random=5',
      type: 'service',
      price: 30,
      quantity: 1,
      status: "rejected", // other values: "approved", "rejected"
    },
  ];
};

export default getTemporaryOrders;
